import { MORTGAGE_FIELDS_LABELS } from '@/entities/mortgage/const';

type CustomerUpdateErrors = Record<string, string | string[]>;

/**
 ** Ошибка бэкенда, которую показываем своим текстом
 */
type ErrorRule = {
  fields: string[];
  test: (error: string) => boolean;
  target?: string;
  message: (field: string) => string;
};

const COMMON_ERRORS_KEY = '__all__';
const CHILDREN_ERRORS_KEY = 'children';

const labels: Record<string, string> = { ...MORTGAGE_FIELDS_LABELS, [CHILDREN_ERRORS_KEY]: 'Дети' };

const ERROR_RULES: ErrorRule[] = [
  {
    fields: [COMMON_ERRORS_KEY],
    test: error => /паспорт|passport/i.test(error) && /уже существует/i.test(error),
    target: 'passport_number',
    message: () => 'Клиент с таким паспортом уже существует'
  },
  {
    fields: ['tax_number', 'work_tax_number', 'add_work_tax_number'],
    test: error => /контрольн/i.test(error),
    message: field => `Некорректный ${labels[field]}`
  }
];

const toList = (errors: string | string[] | undefined) =>
  errors ? (Array.isArray(errors) ? errors : [errors]) : [];

function resolveError(field: string, error: string) {
  const rule = ERROR_RULES.find(rule => rule.fields.includes(field) && rule.test(error));

  if (rule) {
    const formError = rule.message(field);
    return { field: rule.target ?? field, formError, toastLine: formError };
  }

  return { field, formError: error, toastLine: labels[field] ? `${labels[field]}: ${error}` : error };
}

/**
 ** Разбирает `_detail` ошибки сохранения анкеты: ошибки полей формы, ошибки блока «Дети» и текст для тоста
 */
export function parseCustomerUpdateErrors(detail: CustomerUpdateErrors | undefined) {
  const resolved = Object.entries(detail ?? {}).flatMap(([field, errors]) =>
    toList(errors).map(error => resolveError(field, error))
  );

  const controlErrors: Record<string, string[]> = {};
  const childrenErrors: string[] = [];

  resolved.forEach(({ field, formError }) => {
    if (field === CHILDREN_ERRORS_KEY) childrenErrors.push(formError);
    else if (field !== COMMON_ERRORS_KEY) (controlErrors[field] ??= []).push(formError);
  });

  const message = resolved.map(({ toastLine }) => toastLine).join('\n');

  return { controlErrors, childrenErrors, message };
}
